import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAddthisComponent } from './simple-icons-addthis.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAddthisComponent ],
    exports:      [ SimpleIconsAddthisComponent ],
    bootstrap:    []
})
export class SimpleIconsAddthisModule {}
